export default __webpack_public_path__ + "static/media/redT.d6d5747e.svg";